import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithRefresh } from './baseQuery';

export type { RootState } from './baseQuery';

export const baseApi = createApi({
  reducerPath: 'api',
  baseQuery: baseQueryWithRefresh,
  keepUnusedDataFor: 60,
  refetchOnMountOrArgChange: 30,
  refetchOnFocus: true,
  refetchOnReconnect: true,
  tagTypes: [
    'Employee',
    'Shift',
    'Feedback',
    'CarPartReport',
    'CarMakeReport',
    'CarModelReport',
    'Product',
    'Utility',
    'UtilityUnit',
    'Inventory',
    'InventoryType',
    'DetergentData',
    'DetergentPod',
    'Claim',
    'DamageOptions',
    'WashCount',
    'WashCountAdjustment',
    'PurchaseOrder',
    'PurchaseOrderVendor',
    'PurchaseOrderCategory',
    'WorkLog',
    'Site',
    'TaskTemplate',
    'CashierTracking',
  ],
  endpoints: () => ({}),
});
